import React from 'react';
import PropTypes from 'prop-types';
import { Portal } from 'react-portal';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Route } from 'react-router';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { Link, BrowserRouter } from 'react-router-dom';
import {
    applicationDownloadUrl, applicationSteps, describeAllObject, getAllSchool,
    removeLoading, registerRecordType, updateAttachment, updateRegistrationData, resetApplicationId,
    renewApplication, updateRenewState, changeDraftId,
} from './actions';
import Stepper from './Stepper';
import Tab1 from './Tab1';
import Tab2 from './Tab2';
import Tab3 from './Tab3';
import Tab4 from './Tab4';
import Tab5 from './Tab5';
import { getQueryVariable } from '../../../utils/common';
import { spmfcloudFunctionUrl } from '../../../actions/salesforces';

class Registration extends React.Component {
    constructor() {
        super();
        this.state = {};
        this.renderButtonProcess = this.renderButtonProcess.bind(this);
    }

    async componentWillMount() {
        this.props.describeAllObject(); // get picklist value from salesforce
        this.props.getAllSchool(); //fetch school options from salesforce
        this.props.registerRecordType(); //get record type id
        window.onbeforeunload = () => {
            if (this.props.tab2 !== null) {
                this.props.removeLoading();
                this.props.updateAttachment(3, []);
                this.props.updateAttachment(4, []);
                return 'Do you really want to leave this screen?';
            }
            return null;
        };
        const draftId = getQueryVariable('draftId');
        if (draftId) { //this is for continue on draft function
            this.props.changeDraftId(draftId);
            const draftRecords = await fetch(`${spmfcloudFunctionUrl}/draft/applications/${draftId}`, {
                headers: {
                    'hash-token': this.props.user.siteToken.hash,
                },
            }).then(res => res.json());
            if (draftRecords.status === 200) { //fetch filled draft value from db and set stored value to all tab
                this.props.updateRegistrationData('2', draftRecords.data.tab2);
                this.props.updateRegistrationData('3', draftRecords.data.tab3);
                this.props.updateRegistrationData('4', draftRecords.data.tab4);
                this.props.updateAttachment(4, draftRecords.data.attachment.tab4);
                this.props.updateAttachment(3, draftRecords.data.attachment.tab3);
                
                if (draftRecords.data.isRenew) {
                    this.props.updateRenewState();
                }
            }
        }

        const isNew = getQueryVariable('new');
        if (isNew === 'true') {
            this.props.resetApplicationId();
        }

        const applicationIdRenew = getQueryVariable('renewFrom');
        if (applicationIdRenew) {
            this.props.renewApplication(applicationIdRenew);
        }
    }

    componentWillUnmount() {
        this.props.removeLoading();
    }

    renderButtonProcess() {
        const { currentStep } = this.props;
        let buttons = [
            <Link
                to={`/portal/registration-v2/step-${currentStep - 1}`}
                key="prev"
                className="btn btn-primary btn-fill btn-100"
                onClick={() => window.scrollTo({ top: 0 })}
            >
                <i className="fa fa-arrow-left" />
                Prev
            </Link>,
            <Link
                to={`/portal/registration-v2/step-${currentStep + 1}`}
                key="next"
                className="btn btn-primary btn-fill btn-100"
                onClick={() => window.scrollTo({ top: 0 })}
            >
                Next
                <i className="fa fa-arrow-right" />
            </Link>,
        ];
        if (currentStep === 0) {
            buttons = buttons.splice(1, 1);
        } else if (currentStep === 4) {
            buttons = buttons.splice(0, 1);
        }
        return buttons;
    }

    render() {
        const { currentStep } = this.props;
        return (
            <div className="registrationForm container-fluid">
                <div className="container body col-lg-12 col-sm-12 col-xs-12 col-md-12" id="printed">
                    <div className="col-md-12" id="logoHeader">
                        <div className="col-md-2">
                            <img src={require('../../../assets/img/spmf_logo.jpg')} alt="SPMF Logo" width="150px" />
                        </div>
                        <div className="col-md-8">
                            <br /><br />
                            <h3 style={{ color: '#0590ba' }}>&nbsp;&nbsp;STSPMF Application Form</h3>
                        </div>
                        <div className="col-md-2">
                            <a
                                href={applicationDownloadUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-info btn-fill text-right"
                            >
                                <i className="fa fa-download" /> Download
                            </a>
                        </div>
                    </div>
                    { this.state.isLoading ? <div><i className="fa text-center fa-spinner fa-spin fa-3x fa-fw" /></div> : null }
                    <div className="" id="AppForm">
                        <div className="col-md-12 stepper">
                            <Stepper
                                steps={applicationSteps}
                                activeStep={currentStep}
                                completeColor="white"
                                completeTitleColor="white"
                                // circleFontSize={18}
                                circleFontColor="#1bb4e2"
                                activeColor="white"
                                activeTitleColor="white"
                                completeBarColor="white"
                            />
                        </div>
                        {/* this.state.tabIndex */}
                        <div id="PrintedForm">
                            <TransitionGroup>
                                <CSSTransition key={this.props.location.key} classNames="fade" timeout={100}>
                                    <BrowserRouter basename="/portal/registration-v2/">
                                        <div className="step">
                                            <Route exact path="/" component={Tab1} />
                                            <Route path="/step-0" component={Tab1} />
                                            <Route path="/step-1" component={Tab2} />
                                            <Route path="/step-2" component={Tab3} />
                                            <Route path="/step-3" component={Tab4} />
                                            <Route path="/step-4" component={Tab5} />
                                        </div>
                                    </BrowserRouter>
                                </CSSTransition>
                            </TransitionGroup>
                        </div>
                        <br />
                        <div className="text-center">
                            <br />
                        </div>
                    </div>
                </div>
                <div
                    className="modal-backdrop"
                    id="basicExampleModal"
                    tabIndex="-1"
                    role="dialog"
                    style={{ display: this.props.loading ? 'block' : 'none' }}
                >
                    <div className="modal-dialog modal-sm" role="document">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="text-center">
                                    <i className="fa fa-2x fa-spinner fa-spin" />
                                    <br />
                                    {this.props.loadingText}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Registration.propTypes = {
    location: PropTypes.object.isRequired,
    describeAllObject: PropTypes.func.isRequired,
    currentStep: PropTypes.number,
    getAllSchool: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    loadingText: PropTypes.string,
    removeLoading: PropTypes.func.isRequired,
    registerRecordType: PropTypes.func.isRequired,
    tab2: PropTypes.object.isRequired,
    updateAttachment: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    updateRegistrationData: PropTypes.func.isRequired,
    resetApplicationId: PropTypes.func.isRequired,
    renewApplication: PropTypes.func.isRequired,
    updateRenewState: PropTypes.func.isRequired,
    changeDraftId: PropTypes.func.isRequired,
};

Registration.defaultProps = {
    currentStep: 0,
    loading: false,
    loadingText: 'Saving...',
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({
        describeAllObject,
        getAllSchool,
        removeLoading,
        registerRecordType,
        updateAttachment,
        updateRegistrationData,
        resetApplicationId,
        renewApplication,
        updateRenewState,
        changeDraftId,
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
    salesforce: state.salesforce,
    currentStep: state.registration.currentStep,
    tab2: state.registration.tab2,
    loading: state.registration.loading,
    loadingText: state.registration.loadingMessage,
});


export default connect(mapStateToProps, mapDispatchToProps)(Registration);



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Registration/index.js
// module id = 1005
// module chunks = 0